import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';
import { CustomToast } from '../../../util/CustomToast';

import { Storage } from '@ionic/storage';

import { ImageSelector } from '../../../util/imageSelector/imageSelector';

@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
  providers : [HttpClient, CustomToast]
})
export class ProfilePage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;

  image = {
    id : -1,
    filename : 'addimage.png'
  };

  researchlines;
  persontypes;
  groups;

  person = {
    id: '',
    name : '',
    surname1 : '',
    surname2 : '',
    research_line_id : -1,
    person_type_id : -1,
    username : '',
    category_es : '',
    category_en : '',
    email : '',
    phone : '',
    extension : '',
    institution : '',
    researcherid : '',
    google_scholar : '',
    external_link : '',
    image : '',
    orcid : '',
    role : -1,
    tags_es : '',
    tags_en : '',
    scopus: '',
    group_id: -1,
  };

  oldpassword = '';
  newpassword = '';
  newpassword2 = '';

  customToast : CustomToast;
  events : Events;
  storage : Storage;
  alertCtrl : AlertController;

  profileName = '';

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events,storage : Storage, alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();
    
    this.customToast = customToast;
    this.events = events;
    this.storage = storage;
    this.alertCtrl = alertCtrl;
    this.httpCallResearchLines();
    this.httpCallPersonTypes();
    this.httpCallMe();
    this.httpCallGroups();
	}

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector, {isProfile : true});
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        console.log(image);
        this.image = image;
        this.person.image = this.image.filename;
      }
    });
  }

  httpCallResearchLines(){
    this.httpClient.get('/researchlines', (error,data)=>{
      if(!error){
        this.researchlines = data.json();
      }
    });
  }

  httpCallPersonTypes(){
    this.httpClient.get('/persontypes', (error,data)=>{
      if(!error){
        this.persontypes = data.json();
      }
    });
  }

  httpCallGroups() {
    this.httpClient.get("/groups", (error, data) => {
      if (!error) {
        this.groups = data.json();
      }
    });
  }


  httpCallMe(){
    this.httpClient.get('/users/me', (error,data)=>{
      this.person = data.json();
      switch (this.person.role) {
        case 1:
          this.profileName = 'Administrador';
          break;
        case 2:
          this.profileName = 'Investigador';
          break;
        case 3:
          this.profileName = 'Publicador';
          break;
        default:
          this.profileName = '';
          break;
      }
      if(this.person.image){
        this.image.filename = this.person.image;
      }
    });
  }

  onClickSave(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a modificar la información de tu perfil',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.checkGroupCoordinator();
          }
        }
      ]
    });
    alert.present();
  }

  checkGroupCoordinator() {
    let isCoordinator:boolean = false
    let isChangingGroup:boolean = false
    let coordinatingGroupId: number;

    isCoordinator = this.groups.some(g =>{ 
      
      const condition = g.coordinator_id === this.person.id
      if (condition)
      {
    coordinatingGroupId= g.id 
    return true
      }
    })

    isChangingGroup = this.person.group_id != coordinatingGroupId;

    if(isCoordinator && isChangingGroup)
      this.customToast.showMessage(
        "Para cambiar de grupo debe dejar de ser coordinador del actual. Contacte con administración",
        2000
      );
    else{
      this.httpClient.put('/users/me',this.person,(error,data)=>{
        if(!error){
          this.customToast.showMessage('Perfil actualizado correctamente',4000);
        }else{
          this.customToast.showMessage('No se ha podido actualizar el perfil',4000);
        }
      });
     }
  }

  onClickChangePassword(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a cambiar tu contraseña',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.changePassword();
          }
        }
      ]
    });
    alert.present();
  }

  changePassword(){
    if(this.oldpassword.trim().length > 0 && this.oldpassword.trim().length >= 6){
      if(this.newpassword.length >= 6){
        if(this.newpassword == this.newpassword2){
          this.httpCallChangePassword(this.oldpassword.trim(),this.newpassword.trim());
        }else{
          this.customToast.showMessage('La contraseña no coincide',4000);
        }
      }else{
        this.customToast.showMessage('La contraseña debe tener al menos 6 caracteres',4000);
      }
    }else{
      this.customToast.showMessage('La contraseña debe tener al menos 6 caracteres',4000);
    }
  }

  httpCallChangePassword(oldpassword,newpassword){
    this.httpClient.post('/users/me/password',{oldpassword : oldpassword, newpassword : newpassword},(error,data)=>{
        if(error){
          this.customToast.showMessage('La contraseña actual no es correcta',4000);
        }else{
          this.storage.ready().then(()=>{
            this.storage.set('x-access-token',data.text()).then(()=>{
              this.clearInput();
              this.httpCallMe();
              this.customToast.showMessage('Contraseña actualizada correctamente',4000);
            });
          });
        }
      });
  }

  clearInput(){
    this.oldpassword = '';
    this.newpassword = '';
    this.newpassword2 = '';
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/profile/profile.ts